import { render, staticRenderFns } from "./brokers.vue?vue&type=template&id=b6a9917e&"
import script from "./brokers.vue?vue&type=script&lang=js&"
export * from "./brokers.vue?vue&type=script&lang=js&"
import style0 from "./brokers.vue?vue&type=style&index=0&id=b6a9917e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports